var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnowy6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blur",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.05
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#blur)",
    id: "snowy-6"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,10)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "am-weather-cloud-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.7,35.4c0-4.6-3.7-8.2-8.2-8.2c-1,0-1.9,0.2-2.8,0.5c-0.3-3.4-3.1-6.2-6.6-6.2c-3.7,0-6.7,3-6.7,6.7c0,0.8,0.2,1.6,0.4,2.3    c-0.3-0.1-0.7-0.1-1-0.1c-3.7,0-6.7,3-6.7,6.7c0,3.6,2.9,6.6,6.5,6.7l17.2,0C44.2,43.3,47.7,39.8,47.7,35.4z",
    fill: "#57A0EE",
    stroke: "#FFFFFF",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    transform: "translate(-20,-11)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "am-weather-snow-1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3,28)"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#57A0EE",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    transform: "translate(0,9), rotate(0)",
    x1: 0,
    x2: 0,
    y1: -2.5,
    y2: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#57A0EE",
    strokeLinecap: "round",
    strokeWidth: 1,
    transform: "translate(0,9), rotate(45)",
    x1: 0,
    x2: 0,
    y1: -2.5,
    y2: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#57A0EE",
    strokeLinecap: "round",
    strokeWidth: 1,
    transform: "translate(0,9), rotate(90)",
    x1: 0,
    x2: 0,
    y1: -2.5,
    y2: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#57A0EE",
    strokeLinecap: "round",
    strokeWidth: 1,
    transform: "translate(0,9), rotate(135)",
    x1: 0,
    x2: 0,
    y1: -2.5,
    y2: 2.5
  }))), /*#__PURE__*/React.createElement("g", {
    className: "am-weather-snow-2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11,28)"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#57A0EE",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    transform: "translate(0,9), rotate(0)",
    x1: 0,
    x2: 0,
    y1: -2.5,
    y2: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#57A0EE",
    strokeLinecap: "round",
    strokeWidth: 1,
    transform: "translate(0,9), rotate(45)",
    x1: 0,
    x2: 0,
    y1: -2.5,
    y2: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#57A0EE",
    strokeLinecap: "round",
    strokeWidth: 1,
    transform: "translate(0,9), rotate(90)",
    x1: 0,
    x2: 0,
    y1: -2.5,
    y2: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#57A0EE",
    strokeLinecap: "round",
    strokeWidth: 1,
    transform: "translate(0,9), rotate(135)",
    x1: 0,
    x2: 0,
    y1: -2.5,
    y2: 2.5
  }))), /*#__PURE__*/React.createElement("g", {
    className: "am-weather-snow-3"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,28)"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#57A0EE",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    transform: "translate(0,9), rotate(0)",
    x1: 0,
    x2: 0,
    y1: -2.5,
    y2: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#57A0EE",
    strokeLinecap: "round",
    strokeWidth: 1,
    transform: "translate(0,9), rotate(45)",
    x1: 0,
    x2: 0,
    y1: -2.5,
    y2: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#57A0EE",
    strokeLinecap: "round",
    strokeWidth: 1,
    transform: "translate(0,9), rotate(90)",
    x1: 0,
    x2: 0,
    y1: -2.5,
    y2: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#57A0EE",
    strokeLinecap: "round",
    strokeWidth: 1,
    transform: "translate(0,9), rotate(135)",
    x1: 0,
    x2: 0,
    y1: -2.5,
    y2: 2.5
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowy6);
export default __webpack_public_path__ + "static/media/snowy-6.abf211998f21d5289adb043ca67087ad.svg";
export { ForwardRef as ReactComponent };